@if ((dataService.reportStatus$ | async) == ReportStatusEnum.Loading) {
  <dirt-report-loading></dirt-report-loading>
} @else {
  @let drawerDetails = dataService.drawerDetails$ | async;
  <div class="tw-mt-4 tw-flex tw-flex-col">
    <div class="tw-flex tw-mb-4 tw-gap-4 tw-items-center">
      <bit-search
        [placeholder]="'searchApps' | i18n"
        class="tw-min-w-96 tw-w-1/2"
        [formControl]="searchControl"
      ></bit-search>

      <bit-chip-select
        [placeholderText]="'filter' | i18n"
        placeholderIcon="bwi-sliders"
        [options]="filterOptions()"
        [ngModel]="selectedFilter()"
        (ngModelChange)="setFilterApplicationsByStatus($event)"
        fullWidth="false"
        class="tw-min-w-48"
      >
      </bit-chip-select>

      <button
        type="button"
        [buttonType]="'primary'"
        bitButton
        class="tw-ml-auto"
        [disabled]="!selectedUrls().size"
        [loading]="markingAsCritical()"
        (click)="markAppsAsCritical()"
      >
        <i class="bwi tw-mr-2" [ngClass]="selectedUrls().size ? 'bwi-star-f' : 'bwi-star'"></i>
        {{ "markAppAsCritical" | i18n }}
      </button>
    </div>

    <app-table-row-scrollable-m11
      [dataSource]="dataSource"
      [showRowMenuForCriticalApps]="false"
      [selectedUrls]="selectedUrls()"
      [openApplication]="drawerDetails.invokerId || ''"
      [checkboxChange]="onCheckboxChange"
      [showAppAtRiskMembers]="showAppAtRiskMembers"
    ></app-table-row-scrollable-m11>

    @if (emptyTableExplanation()) {
      <div class="tw-flex tw-mt-10 tw-justify-center">
        <span bitTypography="body2">{{ emptyTableExplanation() }}</span>
      </div>
    }
  </div>
}
